import { configureStore } from "@reduxjs/toolkit";
import chatReducer from "./reducers/chatSlice";
import userReducer from "./reducers/userSlice"; // must match user slice

export const store = configureStore({
  reducer: {
    chat: chatReducer,
    user: userReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
